export enum userSettingsComponentsEnum {
  UserProfile = 'User Profile',
  WebsiteLogo = 'Website Logo',
  Renewals = 'Renewals'
}